import React from 'react';

export const GreenCheck: React.FC<{ className?: string }> = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" className={className}>
    <path fill="#0DD149" d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M18.415 8.843a.441.441 0 0 1-.007.622l-7.618 7.477a.441.441 0 0 1-.618 0L5.341 12.2a.441.441 0 0 1-.008-.623l1.421-1.462a.441.441 0 0 1 .626-.007l2.792 2.74a.441.441 0 0 0 .618 0l5.579-5.475a.441.441 0 0 1 .625.007l1.421 1.463Z"
      clipRule="evenodd"
    />
  </svg>
);
